export default __webpack_public_path__ + "img/4372975021ff38657e63bd920e07481c.png";